import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule } from '@angular/router';

import { AccountSetupRouteReuseStrategy } from './account-setup.route-reuse-strategy';
import { NotFoundComponent } from './not-found/not-found.component';
import { AccountSetupI18nResolver } from './shared/account-setup-i18n-resolver.service';
import { AccountSetupSharedModule } from './shared/shared.module';

@NgModule({
  providers: [{ provide: RouteReuseStrategy, useClass: AccountSetupRouteReuseStrategy }],
  imports: [
    RouterModule.forRoot(
      [
        {
          path: ':lang',
          resolve: [AccountSetupI18nResolver],
          children: [
            {
              path: ':token/company',
              loadChildren: () =>
                import('./company/company.module').then(m => m.AccountSetupCompanyModule),
            },
            {
              path: ':token/user',
              loadChildren: () => import('./user/user.module').then(m => m.AccountSetupUserModule),
            },
            { path: '404', component: NotFoundComponent },
            { path: '**', redirectTo: '404', pathMatch: 'full' },
          ],
        },
        { path: '**', redirectTo: 'en/404', pathMatch: 'full' },
      ],
      {
        paramsInheritanceStrategy: 'always',
      },
    ),
    AccountSetupSharedModule,
  ],
  exports: [RouterModule],
})
export class AccountSetupRoutingModule {}
